import * as React from 'react';
import { IconActionChevronRightSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { IBreadcrumb } from '../../types/developer/breadcrumbs';
import { Layout } from '../Layout';
import * as style from './styles.css';

export interface IBreadCrumbsProps {
  breadcrumbs: IBreadcrumb[];
}

export class BreadCrumbs extends React.PureComponent<IBreadCrumbsProps> {
  public render() {
    const { breadcrumbs } = this.props;

    if (!breadcrumbs.length) {
      return null;
    }

    return (
      <div className={style['container']}>
        <Layout stretch>
          {breadcrumbs.map((crumb, index) => {
            return (
              <React.Fragment key={index}>
                {index === 0 ? null : (
                  <span className={style['arrow']}>
                    <IconActionChevronRightSmall16 color="white_60" />
                  </span>
                )}
                <a className={style['crumb']} href={crumb.url} title={crumb.title}>
                  {crumb.title}
                </a>
              </React.Fragment>
            );
          })}
        </Layout>
      </div>
    );
  }
}
